import { SelectInput } from '@core/components/Select';
import React from 'react';

const ListaDeOcorrencia = ({
  id,
  required,
  value,
  onChange,
  onBlur,
  error,
  touched,
  helperText,
  readOnly,
  disabled,
}) => {
  return (
    <SelectInput
      id={id}
      label="Quando"
      fullWidth
      required={required}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      touched={touched}
      error={error}
      helperText={helperText}
      readOnly={readOnly}
      options={[
        { id: 'DIARIO', title: 'Diariamente' },
        { id: 'SEMANAL', title: 'Semanalmente' },
        { id: 'QUINZENAL', title: 'Quinzenalmente' },
        { id: 'MENSAL', title: 'Mensalmente' },
        { id: 'BIMESTRAL', title: 'Bimestralmente' },
        { id: 'TRIMESTRAL', title: 'Trimestralmente' },
        { id: 'SEMESTRAL', title: 'Semenstralmente' },
        { id: 'ANUAL', title: 'Anualmente' },
      ]}
      disabled={disabled}
    />
  );
};

export default ListaDeOcorrencia;
